import HomeComponent from "../components/Home/Home";

const Home = (): JSX.Element => <HomeComponent />;

export default Home;
